import { Pipe, PipeTransform } from '@angular/core';
import { differenceInDays } from 'date-fns';

@Pipe({
  name: 'diffInDays',
})
export class DiffInDaysPipe implements PipeTransform {
  transform(value: Date | string): number {
    return differenceInDays(new Date(), value);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/diff-in-days.pipe.ts